import { render, staticRenderFns } from "./TreatmentPlanPDF.vue?vue&type=template&id=fb3f5784&"
import script from "./TreatmentPlanPDF.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlanPDF.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlanPDF.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports